// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__V1ehP","name":"Header_name__86fUA","birthday":"Header_birthday__3_BH_","skeleton":"Header_skeleton__2HfHI"};